module.exports = __webpack_public_path__ + "media/images/house-8dc48865d38754ddeaf8196b105e1eec.png";